import FilterForm from '../../../components/forms/FilterForm';
import dayjs from 'dayjs';
import { CrudFilters, HttpError } from '@refinedev/core';
import { DateField, EditButton, TextField, useTable } from '@refinedev/antd';
import { DatePicker, Form, Input, Select, Table } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { ICoupon } from 'interfaces/coupons';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { STATUSES, translateStatus } from 'services/coupons';
import { replaceTimeZone } from '../../../services/date';

interface IFilter {
  name: string;
  status: string;
  campaignId: string;
  code: string;
  byExpiresAt: dayjs.Dayjs;
}

export const CouponList = () => {
  const { tableProps, searchFormProps } = useTable<ICoupon, HttpError, IFilter>(
    {
      onSearch: params => {
        const filters: CrudFilters = [];
        const { status, code, byExpiresAt } = params;

        filters.push(
          {
            field: 'filter[status]',
            operator: 'eq',
            value: status
          },
          {
            field: 'filter[code]',
            operator: 'eq',
            value: code
          },
          {
            field: 'filter[by_expires_at]',
            operator: 'eq',
            value: byExpiresAt && replaceTimeZone(byExpiresAt)
          }
        );

        return filters;
      }
    }
  );

  return (
    <ListLayout title="Cupons">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="code">
          <Input placeholder="Código do cupom" className="lg:min-w-[300px]" />
        </Form.Item>

        <Form.Item name="status">
          <Select placeholder="Status">
            {STATUSES.map(status => (
              <Select.Option key={status}>
                {translateStatus(status)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="byExpiresAt">
          <DatePicker placeholder="Data de expiração" format="DD/MM/YYYY" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="code"
          key="code"
          title="Código"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="description"
          key="description"
          title="Descrição"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="status"
          key="status"
          title="Status"
          render={value => <TextField value={translateStatus(value)} />}
        />
        <Table.Column
          dataIndex="expires_at"
          key="expires_at"
          title="Expiração"
          render={value => <DateField value={value} />}
        />
        <Table.Column<ICoupon>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <EditButton
                hideText
                size="small"
                icon={<EyeOutlined />}
                recordItemId={record.id}
              />
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
